//
//
//
//
//
//
//

export default {
  name: "directHeading",
  props: {
    headerText: {
      type: String,
      default: "",
    },
    subheaderText: {
      type: String,
      default: "",
    },
  },
};
